import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';

const defaultColumns = [
	{
		components: [],
		offset:     0,
		pull:       0,
		push:       0,
		width:      6,
	},
	{
		components: [],
		offset:     0,
		pull:       0,
		push:       0,
		width:      6,
	},
];

export default class ColumnsComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentColumns | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.columns = settings?.columns.map(column => ({
			...column,
			components: column.components?.map((/** @type {any} */ c) => createComponentInstance(c)),
		})) ?? defaultColumns
	}
}
